<template>
  <span :id="id" class="match__dice"><vue-audio :file="7" ref="dice" v-show="id === 'userDiceS' || id === 'pcDiceS'" :loop="true"></vue-audio></span>
</template>
<script>
  import { store } from '../store/store'
  import Audio from './Audio'

  export default {
    name: 'Dice',
    data () {
      return {
        positionX: 72,
        timeLine: -1,
        objCounter: {counter: 0},
        result: 0
      }
    },
    props: ['id'],
    components: {
      'vue-audio': Audio
    },
    computed: {
      diceData () {
        return store.state.dice
      },
      diceStatus () {
        let status = -1
        switch (this.id) {
          case 'userDiceL':
          case 'userDiceS':
            status = 'user'
            break
          case 'pcDiceL':
          case 'pcDiceS':
            status = 'pc'
            break
        }
        return status
      },
      diceStage () {
        return store.state.diceStage[this.diceStatus]
      },
      resetStatus () {
        return store.state.resetStatus
      }
    },
    watch: {
      diceStage (val) {
        if (val) {
          if (this.diceStatus === 'pc') {
            this.timeLine.addPause(2, this.onPcComplete)
            this.timeLine.play()
          } else {
            this.timeLine.play()
          }
          // Play audio
          if (this.id === 'pcDiceS' || this.id === 'userDiceS') {
            setTimeout(() => { this.$refs.dice.play() }, this.id === 'pcDiceS' ? 0 : 150)
          }
        } else {
          // Stop audio
          this.$refs.dice.stop()
          // Stop dice
          this.timeLine.pause(0)
          this.setDiceData()
          if (this.id === 'userDiceS') {
            store.getters.getCalculateDistance('horseUser')
            store.dispatch('setHorseRun', {
              'currentHorse': this.diceStatus,
              'raceStatus': true
            })
          }
        }
      },
      resetStatus (val) {
        if (val) {
          this.timeLine.pause()
          this.timeLine.kill()
        }
      }
    },
    methods: {
      getPositionXRandom () {
        let number = Math.floor(Math.random() * 6)
        this.result = number + 1
        return -number * this.positionX + 'px'
      },
      repeatShakeDice () {
        if (this.objCounter.counter < 6) {
          TweenMax.to('#' + this.id, 0, {backgroundPosition: this.getPositionXRandom})
        }
      },
      onPcComplete () {
        this.setDiceData()
        if (this.id === 'pcDiceS') {
          store.getters.getCalculateDistance('horsePc')
        }
        store.dispatch('setHorseRun', {
          'currentHorse': 'pc',
          'raceStatus': true
        })
        store.dispatch('setDiceRun', {
          'currentDice': 'pc',
          'diceStatus': false
        })
      },
      shakeDice () {
        let tm = TweenMax.to(this.objCounter, 0.1,
          {
            counter: 6,
            repeat: -1,
            onRepeat: this.repeatShakeDice,
            repeatDelay: 0.1,
            ease: SteppedEase.config(6)
          })
        this.timeLine = new TimelineMax()
        this.timeLine.append(tm)
        this.timeLine.pause()
      },
      setDiceData () {
        let temp = []
        let diceType = ''
        switch (this.id) {
          case 'userDiceL':
            temp = this.diceData.user
            temp[0] = this.result
            diceType = 'user'
            break
          case 'userDiceS':
            temp = this.diceData.user
            temp[1] = this.result
            diceType = 'user'
            break
          case 'pcDiceL':
            temp = this.diceData.pc
            temp[0] = this.result
            diceType = 'pc'
            break
          case 'pcDiceS':
            temp = this.diceData.pc
            temp[1] = this.result
            diceType = 'pc'
            break
        }
        store.dispatch('setDice', {
          'currentDice': diceType,
          'diceData': temp
        })
      }
    },
    mounted () {
      this.shakeDice()
    }
  }
</script>



// WEBPACK FOOTER //
// Dice.vue?3f88f4dc